import i18next from 'i18next';
import { formatMonth } from 'infrastructure/functions/monthFormater';
import BingoActions from 'components/organisms/admin-panel/patient-detail/bingoActions';

import s from './styles.module.scss';
import BingoWonStatus from './BingoWonStatus';

import type { IPatientBingoProgress } from 'infrastructure/interfaces/i-patient-bingo-progress';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

export const BingoCardProgressColumns =
  (): IBaseTableColumns<IPatientBingoProgress> => {
    return [
      {
        label: i18next.t('labels.bingoCardId'),
        align: 'left',
        key: 'cardNumber',
        width: '20%',
        render(value) {
          return (
            <span className={s.cardId} data-cy="bingo-partNumber">
              #{value}
            </span>
          );
        },
      },
      {
        label: i18next.t('labels.date'),
        align: 'left',
        width: '20%',
        key: 'year',
        render(_, value) {
          return (
            <span className={s.date} data-cy="bingo-date">
              <p>
                {`${formatMonth(value.month)}`}/{`${value.year}`}
              </p>
            </span>
          );
        },
      },
      {
        label: i18next.t('labels.bingoStatus'),
        align: 'left',
        key: 'isWon',
        width: '20%',
        render(_, value: IPatientBingoProgress) {
          return <BingoWonStatus value={value} />;
        },
      },
      {
        label: i18next.t('labels.openedNumbers'),
        align: 'left',
        key: 'openedNumbers',
        width: '40%',
        render(value: number[]) {
          return (
            <span className={s.cardId} data-cy="bingo-openedNumbers">
              {value.join(', ')}
            </span>
          );
        },
      },
      {
        label: '',
        align: 'left',
        key: 'cardNumber',
        width: '5%',
        render(cardNumber, value) {
          const { bingoNumbers, openedNumbers } = value;
          return (
            <span className={s.cardId} data-cy="bingo-actions">
              <BingoActions
                cardNumber={cardNumber}
                bingoNumbers={bingoNumbers}
                openedNumbers={openedNumbers}
              />
            </span>
          );
        },
      },
    ];
  };
